module.exports = __webpack_public_path__ + "media/images/svgs/rays-c9e4c19a9cc27bbf882181453cc758b4.svg";